<template>
  <div class="exhibition">
    <flickity class="flickity" id ="expo" ref="flickity" :options="flickityOptions">
      <div class="carousel-cell" data-href="/libros/autoras"><img class="carousel-cell-image" alt="La femme de la femme" src="../assets/carousel/autoras.png"></div>
      <div class="carousel-cell" data-href="/libros/criminal"><img class="carousel-cell-image" alt="Delitos sin faltas" src="../assets/carousel/criminal.png"></div>
      <div class="carousel-cell" data-href="/libros/ilustrado"><img class="carousel-cell-image" alt="Cariátide" src="../assets/carousel/ilustrado.png"></div>
      <div class="carousel-cell" data-href="/libros/infantilyjuvenil"><img class="carousel-cell-image" alt="Cariátide" src="../assets/carousel/infantil-juvenil.png"></div>
      <div class="carousel-cell" data-href="/libros/otros"><img class="carousel-cell-image" alt="Sui generis" src="../assets/carousel/otros.png"></div>
      <div class="carousel-cell" data-href="/articulos"><img class="carousel-cell-image" alt="La signora Cronopio" src="../assets/carousel/articulos.png"></div>
    </flickity>
  </div>
</template>

<script>
import Flickity from 'vue-flickity'

export default {
  components: {
    Flickity
  },
  data () {
    return {
      flickityOptions: {
        prevNextButtons: false,
        pageDots: true,
        wrapAround: true,
        imagesLoaded: true,
        lazyLoad: true,
        initialIndex: 1
      }
    }
  },
  mounted () {
    this.slideEventListener()
    this.resetCarousel()
    document.querySelector('#expo').focus()
  },
  activated () {
    this.resetCarousel()
  },
  methods: {
    slideEventListener () {
      this.$refs.flickity.on('staticClick', (event, pointer, cellElement, cellIndex) => {
        if (!cellElement) {
          return
        }
        var carousel = this.$refs.flickity.data(document.querySelector('.carousel'))
        var route = carousel.selectedElement.dataset.href
        this.$router.push(route)
      })
    },
    resetCarousel () {
      var carousel = this.$refs.flickity.data(document.querySelector('.carousel'))
      var index = (this.$route.query.cuadro !== undefined)
        ? this.$route.query.cuadro
        : 0

      carousel.select(index)
    }
  }
}
</script>

<style scoped lang="scss">

$debug: false;

  .exhibition {
    margin-top: 50px;
  }

  #navbar {
  @if $debug == true {
    border: solid 1px #0000FF;
    background-color: beige;
  }

  height: 8vh;
  padding: 1em;
}

#nav {
  padding: 0px;

  a {
    font-size: 1.2em;
    font-weight: bold;
    color: #2c3e50;
    text-decoration: none;

    &.router-link-exact-active {
      color: #631c2c;
    }
  }

  a:hover {
    color: #631c2c;
  }
}

/* .carousel { height: 100%; } */

.carousel-cell {
  width: 100%; /* full width */
  height: 574px;
  /* background: #222; */
  /* center images in cells with flexbox */
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 4px;
  padding-bottom: 4px;
}

.carousel-cell img {
  display: block;
  max-height: 100%;
  margin: 0 auto;
  max-width: 100%;
  opacity: 1;
  -webkit-transition: opacity 0.4s;
          transition: opacity 0.4s;

  filter: drop-shadow(0px 0px 6px #666666);
}

// .carousel-cell img:hover {
//   filter: drop-shadow(0px 0px 6px #111111);
// }

// /* fade in lazy loaded image */
// .carousel-cell-image.flickity-lazyloaded,
// .carousel-cell-image.flickity-lazyerror {
//   opacity: 1;
// }

// * { box-sizing: border-box; }

// body { font-family: sans-serif; }

// .carousel {
//   background: #FAFAFA;
// }

// .carousel-cell {
//   width: 66%;
//   height: 400px;
//   margin-right: 10px;
//   background: #333;
// }

// .carousel-cell-image {
//   display: block;
//   max-height: 100%;
//   margin: 0 auto;
//   max-width: 100%;
//   opacity: 0;
//   -webkit-transition: opacity 0.4s;
//           transition: opacity 0.4s;
// }

// /* fade in lazy loaded image */
// .carousel-cell-image.flickity-lazyloaded,
// .carousel-cell-image.flickity-lazyerror {
//   opacity: 1;
// }

</style>
